import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EventLogs } from 'src/app/models/eventLog.model';
import { Plant } from 'src/app/models/plant.model';
import { Train } from 'src/app/models/train.model';
import { EventlogsService } from 'src/app/services/eventlogs/eventlogs.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { TrainService } from 'src/app/services/trains/trains.service';
 
@Component({
  selector: 'app-edit-eventlogs',
  templateUrl: './edit-eventlogs.component.html',
  styleUrls: ['./edit-eventlogs.component.scss'],
})
export class EditEventlogsComponent {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private plantsService: PlantsService,
    private trainService: TrainService,
    private eventlogsService: EventlogsService,
    private toastr: ToastrService,
    private plantService: PlantsService
  ) {}
 
  trainDetails: Train = new Train();
 
  EventLogsDetails: EventLogs = new EventLogs();
  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  plants: Plant[] = [];
  trains: Train[] = [];
  dateNow: Date = new Date();
  SelectedId: string;
  trainId: string;
  plantId: string;
  eventLogId: any;
 
  getSelectedId(e) {
   
    this.SelectedId = e.target.value;
    this.trains.length = 0;
    this.trainService.getTrainByPlantId(this.SelectedId).subscribe(
      (response: Train[]) => {
        this.trains = response;
      },
 
      (error: any) => {
        console.log('error list');
      }
    );
  }
 
  getSelectedIdstart(e) {
    this.trainService.getTrainByPlantId(e).subscribe(
      (response: Train[]) => {
        this.trains = response;
      },
      (error: any) => {
        console.log('error list');
      }
    );
  }
 
  ngOnInit(): void {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User')
    {
      this.plantsService.getPlantsByUserId(loggedInuserRole.userId)
      .subscribe({
        next: (plants)=>{
          this.plants = plants;
        },
      })
     
    }
    else
    {
    this.plantsService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
      },
      error: (response) => {
        console.log(response);
      },
    });
  }
    this.route.paramMap.subscribe({
      next: (params) => {
        const id = atob(params.get('id')!);
         console.log(id);
        if (id) {
          this.eventlogsService.getEventLogsById(id).subscribe({
            next: (response) => {
              this.EventLogsDetails = response;
              console.log(this.EventLogsDetails);
              this.trainId = this.EventLogsDetails.TrainId.toString();
 
              this.trainService.getTrainById(this.trainId).subscribe({
                next: (response) => {
                  this.trainDetails = response;
                  console.log(this.trainDetails);
                  this.trains.length = 0;
                  this.plantId = this.trainDetails.PlantId.toString();
 
                  this.getSelectedIdstart(this.plantId);
                },
              });
 
             
            },
          });
        }
      },
    });

         // get plantId from breadcrumbs
    this.plantService.selectedPlant$
      .subscribe(plantId => {
        if (plantId) {
          this.getSelectedId({ target: { value: plantId } });
        }
      });
  }
 
  updateEventLogs() {
    const dateNowISO = this.dateNow.toISOString();
    this.EventLogsDetails.UpdatedAt = dateNowISO;
    console.log(this.EventLogsDetails);
 
    this.eventlogsService
      .updateEventLogs(this.EventLogsDetails.Id, this.EventLogsDetails)
      .subscribe({
        next: (response) => {
          this.toastr.success('Event Updated Successfully.', 'Information');
          this.router.navigate(['/eventlogs']);
        },
      });
  }
 
  deleteEventLogs(id: number) {
    this.eventLogId = id + '';
    const confirmDelete = confirm(
      'Are you sure you want to delete this Event Log?'
    );
 
    if (!confirmDelete) {
      return; // If the user clicks "Cancel" in the confirmation dialog, do nothing.
    }
    this.eventlogsService.deleteEventLogs(this.eventLogId)
    .subscribe((response: Response) => {
      if (response.statusText == 'Success') {
        this.toastr.error('Event Log deleted successfully.', 'Information');
        this.router.navigate(['/eventlogs']);
      } else {
        (error) => {
          console.log('Error deleting Event Log:', error);
        };
      }
    });
  }
}
 
 